import {
  GRAY_SCALE_05,
  GRAY_SCALE_08,
  PRIMARY_BLUE_02,
} from 'bd-web-components/src/utils/dash-colors'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0px 64px;
  height: 100%;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
  .react-auth-modal-content {
    width: 500px !important;
  }
`

export const PageTitle = styled.h4`
  color: ${PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-top: 40px;
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin-top: 27px;
    margin-bottom: 13px;
  }
`

export const PageSubtitle = styled.p`
  color: ${GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 18px;
  }
`

export const FormDivider = styled.div`
  background-color: ${GRAY_SCALE_08};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    margin-top: 29px;
    margin-bottom: 24px;
  }
`

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`

export const RefreshButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: ${PRIMARY_BLUE_02};
  color: #ffffff;
  border: 0;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-left: auto;
  margin-bottom: 8px;
  white-space: nowrap;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-bottom: 18px;
    width: 100%;
    justify-content: center;
  }
`

export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

interface TableContainerProps {
  height: number
  margin: boolean
}

export const ExceptionContainer = styled(styled.div``)<TableContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`
